module.exports = {
          srcSet: __webpack_public_path__ + "b2be224be0267edd7375c63077b87994-30.png"+" 30w",
          images:[ {path: __webpack_public_path__ + "b2be224be0267edd7375c63077b87994-30.png",width: 30,height: 30}],
          src: __webpack_public_path__ + "b2be224be0267edd7375c63077b87994-30.png",
          toString:function(){return __webpack_public_path__ + "b2be224be0267edd7375c63077b87994-30.png"},
          
          width: 30,
          height: 30
        }